<template>
	<div class="modal fade" id="modalDetailDevice" tabindex="-1" role="dialog" aria-labelledby="modalDetailDeviceTitle" aria-hidden="true">
	    <div class="modal-dialog modal-dialog-centered" role="document">
	        <div class="modal-content mx-auto">                           
	            <div class="modal-body">                
	                <p class="f-14 f-m-12"><b>Detail Device</b> 
	                    <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
	                        <span aria-hidden="true">&times;</span>
	                    </button>
	                </p>  
	                <p class="title-colee f-12 mt-4">Status</p>
	                <button class="info warning">{{ !detail?'':detail.col_status }}</button>
	                <hr>
	                <p class="title-colee f-12">Merek dan Tipe device</p>
	                <p class="f-14 f-m-12">{{ !detail?'':detail.merk }}</p>
	                <hr>
	                <div class="row">
	                    <div class="col margin-0">
	                        <p class="title-colee f-12 margin-0">Nomor Handphone</p>
	                        <p class="f-14 f-m-12 margin-0">{{ !detail?'':detail.phone_number }} </p>
	                    </div>
	                    <div class="col margin-0">
	                        <p class="title-colee f-12 margin-0">Nomor IMEI</p>
	                        <p class="f-14 f-m-12 margin-0">{{ !detail?'':detail.imei }}</p>
	                    </div>             
	                </div>                
	                <hr>
					<p class="title-colee f-12">Driver</p>
	                <p class="f-14 f-m-12">{{ !detail?'':detail.col_driver }}</p>
	            </div>
	        </div>
	    </div>
	</div>
</template>

<script>
export default {
	name: 'ModalDetail',
	props: ['detail']
}
</script>